export const ged = {
  errorUploadingDocument: "Erreur lors de l’upload du document",
  uploder: "Uploader un document",
  title: "Titre",
  auteur: "Auteur",
  tags: "Tags",
  dossier: "Dossier",
  choisierDos: "Choisir un dossier",
  version: "Version",
  fichier: "Fichier",
  uploderr: "Uploader",
  selectFile: "Veuillez sélectionner un fichier",
  impossibleToGetDetails: "Impossible de récupérer les détails",
  impossibleToGetVersions: "Impossible de récupérer les versions",
  updateVersion: "Update Version",
  consult: "Consulter",
  versions: "Toutes les versions",
  updateVers: "Mettre à jour la version",
  details: "Détails du document",
  versionCourante: "Version Courante",
  createdAt: "Créé le",
  updatedAt: "Mis à jour le",
  voir: "Voir le fichier",
  telecharger: "Télécharger",
  close: "Fermer",
  versionss: "Versions du document",
  aucun: "Aucune version disponible",
  nomObligatoire: "Nom obligatoire",
  retour: "Retour",
  resutatDos: "Résultats dossiers",
  resultatDoc: "Résultats documents",
  contenu: "Contenu du dossier",
  nouveauDos: "Nouveau dossier",
  nouveauDoc: "Nouveau document",
  sousDos: "Sous-dossiers",
  doc: "Documents",
  nomDos: "Nom du dossier",
  creer: "Créer",
  gestion: "Gestion des Dossiers et Documents",
  recherche: "Recherche..",
  racin: "Dossiers racine",
  option: "Dossier parent (optionnel)",
  rac: "Racine",
};
